module.exports = "<img src=\"assets/crab_flota_logo2_70short.png\" alt=\"MC Flota\">\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/logo/logo.component.html
// module id = ../../../../../src/app/pages/shared/logo/logo.component.html
// module chunks = main